import React from 'react';
import {Avatar as MUIAvatar} from '@material-ui/core';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import SchoolIcon from '@material-ui/icons/School';
import ImageIcon from '@material-ui/icons/Image';

const Avatar = ({ imageId, avatarType = "user", ...rest}) => {
    const src = `/work/api/file/${imageId}`;

    return (
      imageId ? <MUIAvatar src={src} {...rest}  />
      : <MUIAvatar>
          {avatarType === "user" ?
            <AccountCircleIcon fontSize="large"/> :
            avatarType === "program" ?
              <SchoolIcon fontSize="large"/> :
              <ImageIcon fontSize="large"/>
          }
      </MUIAvatar>
    )
}

export default Avatar;
